import axios from 'axios';
import baseUrl from '../config/baseURL';
import { getAuthToken } from '../services/auth';

export const getWANumber = async (organization_id: any) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/whatsapp-number`;
        const response = await axios.get(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the data:', error);
    return { success: false, data: undefined };
  }
};

export const getWAConversations = async (organization_id: any) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/whatsapp-conversations`;
        const response = await axios.get(endpoint, { headers });
        console.log('Response from getWAConversations:', response);
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the data:', error);
    return { success: false, data: undefined };
  }
};

export const getWAConversation = async (
  organization_id: any,
  conversation_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/whatsapp-conversations/${conversation_id}/`;
        const response = await axios.get(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the data:', error);
    return { success: false, data: undefined };
  }
};

export const deleteWAConversation = async (
  organization_id: any,
  conversation_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/whatsapp-conversations/${conversation_id}/`;
        const response = await axios.delete(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the data:', error);
    return { success: false, data: undefined };
  }
};

export const getWAMesages = async (
  organization_id: any,
  conversation_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/whatsapp-conversations/${conversation_id}/messages/`;
        // GET/POST /core/organizations/{organization_pk}/whatsapp-conversations/{conversation_pk}/messages/

        const response = await axios.get(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the data:', error);
    return { success: false, data: undefined };
  }
};

export const sendWAMsg = async (
  conversation_id: string,
  organization_id: string,
  text: string,
  template_name?: string,
  attachment?: File | null,
) => {
  try {
    const token = await getAuthToken();

    if (!token?.success || !token.data) {
      return { success: false, data: 'Token not found' };
    }

    const headers: Record<string, string> = {
      Authorization: `Bearer ${token.data}`,
    };

    const payload = attachment ? new FormData() : ({ body: text } as Record<string, any>);
    if (attachment) {
      payload.append('body', text);
      payload.append('attachment', attachment);
      if (template_name) {
        payload.append('template_name', template_name);
      }
    } else {
      headers['Content-Type'] = 'application/json';
      if (template_name) {
        payload.template_name = template_name;
      }
    }

    const endpoint = `${baseUrl}/core/organizations/${organization_id}/whatsapp-conversations/${conversation_id}/messages/`;
    const response = await axios.post(endpoint, payload, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      console.error('Failed to send WhatsApp message:', response);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error('Unexpected error while sending WhatsApp message:', error);
    return {
      success: false,
      data: error?.response?.data || 'Unexpected error',
    };
  }
};

export const setWANumber = async (
  organization_id: string,
  phone_number: string,
  whatsapp_account_id: string,
  access_token: string,
) => {
  try {
    const token = await getAuthToken();

    if (!token?.success || !token.data) {
      return { success: false, data: 'Token not found' };
    }

    const headers = {
      Authorization: `Bearer ${token.data}`,
      'Content-Type': 'application/json',
    };

    const payload = {
      phone_number,
      whatsapp_account_id,
      access_token,
    };

    const endpoint = `${baseUrl}/core/organizations/${organization_id}/whatsapp-number/`;

    const response = await axios.post(endpoint, payload, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      console.error('Failed to save WhatsApp number:', response);
      return { success: false, data: response.data };
    }
  } catch (error) {
    console.error('Unexpected error while saving WhatsApp number:', error);
    return { success: false, data: error };
  }
};

export const deleteWANumber = async (
  organization_id: any,
  whatsapp_number: any,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/whatsapp-number/${whatsapp_number}/`;
        const response = await axios.delete(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data deletion failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the data:', error);
    return { success: false, data: undefined };
  }
};
